import { createStore } from 'vuex';
import ManageUser from '@/store/common/ManageUser';
import Notifications from '@/store/common/Notifications';
import Course from '@/store/common/CourseTree';
// API
import APISecurity from '@/store/API/Security';
import Inscription from '@/store/API/Inscription';
import Links from '@/store/API/Links';
import Courses from '@/store/API/Courses';
import Profile from '@/store/API/Profile';
import Activities from '@/store/API/Activities';
import Forum from '@/store/API/Forum';
import Resources from './API/Resources';
import Home from './API/Home';
import Stuff from './API/Stuff';
import Editor from './API/CourseCfg';
import Interactions from './API/Interactions';

export default createStore({
  modules: {
    ManageUser,
    Notifications,
    APISecurity,
    Inscription,
    Links,
    Courses,
    Profile,
    Activities,
    Forum,
    Course,
    Resources,
    Home,
    Stuff,
    Editor,
    Interactions,
  }
});